import { useLayoutEffect, useRef, type FormHTMLAttributes, type ReactNode } from 'react';

export type WebMcpFormProps = Omit<FormHTMLAttributes<HTMLFormElement>, 'children'> & {
  toolName: string;
  toolDescription: string;
  /** When set, agents may submit after filling fields (e.g. search). */
  toolAutoSubmit?: boolean;
  children: ReactNode;
};

/** Declarative WebMCP tool registration on a standard HTML form (Chrome origin trial). */
export function WebMcpForm({
  toolName,
  toolDescription,
  toolAutoSubmit = false,
  children,
  ...props
}: WebMcpFormProps) {
  const ref = useRef<HTMLFormElement>(null);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.setAttribute('toolname', toolName);
    el.setAttribute('tooldescription', toolDescription);
    if (toolAutoSubmit) el.setAttribute('toolautosubmit', '');
    else el.removeAttribute('toolautosubmit');
    return () => {
      el.removeAttribute('toolname');
      el.removeAttribute('tooldescription');
      el.removeAttribute('toolautosubmit');
    };
  }, [toolName, toolDescription, toolAutoSubmit]);

  return (
    <form ref={ref} {...props}>
      {children}
    </form>
  );
}
